import React from "react";
import { HashRouter } from "react-router-dom";
import Router from './router/Router';
import useDarkMode from './context/useDarkMode';

function App() {
  const [darkMode, setDarkMode] = useDarkMode();

  return (
    <HashRouter>
      <Router darkMode={darkMode} setDarkMode={setDarkMode} />
    </HashRouter>
  );
}

export default App;